/**
 * @desc Global Parameters
 */
export const GOOGLE_LOGIN_CLIENT_ID = process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID; // Google + API client ID
export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const IS_STAGING_TOOLS_ENABLED = REACT_APP_ENV === 'development' || /^staging/.test(REACT_APP_ENV ?? '');
/**
 * Local dev only: a bookkeeper JWT that keeper-portless signs, so portless URLs
 * (which Google sign-in doesn't accept) start signed in. Empty in deployed builds.
 */
export const DEV_KEEPER_TOKEN = process.env.REACT_APP_DEV_KEEPER_TOKEN;
/**
 * Optional explicit backend URL override. Used by the dockerized E2E build so
 * the app can reach the backend by its compose service name (e.g.
 * http://backend:5001/). Empty in normal builds, where serverUrl() falls back
 * to the per-environment hosts below.
 */
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;

/**
 * @desc Get server URL based on host name
 */
export function serverUrl() {
  if (SERVER_URL) {
    return SERVER_URL;
  }
  if (REACT_APP_ENV === 'development') {
    return 'http://localhost:5001/';
  } else if (REACT_APP_ENV === 'staging') {
    return 'https://keeper-backend-staging.keepertax.com/';
  } else if (REACT_APP_ENV === 'staging-2') {
    return 'https://keeper-backend-staging-2.keepertax.com/';
  } else if (REACT_APP_ENV === 'staging-3') {
    return 'https://keeper-backend-staging-3.keepertax.com/';
  } else if (/^staging-[a-z]+$/.test(REACT_APP_ENV)) {
    return `https://keeper-backend-${REACT_APP_ENV}.keepertax.com/`;
  } else if (REACT_APP_ENV === 'pentest') {
    return 'https://keeper-backend-pentest.keepertax.com/';
  } else if (REACT_APP_ENV === 'production') {
    return 'https://keeper-backend.keepertax.com/';
  }
  throw new Error(`invalid environment: ${REACT_APP_ENV}`);
}
